import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import * as fromDataServices from '../../../data-services';
import * as fromShared from '../../../shared';
import { IColumn, SortEvent } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';
import { ReplaySubject } from 'rxjs';
//import * as FileSaver from 'file-saver';

@Component({
    selector: 'ef-indirect-rate-history-presenter',
    templateUrl: './indirect-rate-history-presenter.component.html',
    styleUrls: ['./indirect-rate-history-presenter.component.scss'],
    standalone: false
})
export class IndirectRateHistoryPresenter
    extends fromShared.EditGrid<fromDataServices.IndirectRateHistory.IndirectRateHistoryModel>
    implements OnInit
{
    @Input() loading: boolean;
    @Input() cols: IColumn[] = [];
    //@Input() colGroups: IColumn[] = [];

    private ColGroupsSubject = new ReplaySubject<any>(1);
    private _colgroups: any;
    @Input() set colGroups(value: any) {
        if (value && value.length > 0) {
            this._colgroups = value;
            this.ColGroupsSubject.next(value);
            setTimeout(() => {
                this.setColGroupWidth(value);
            }, 100);
        }
    }
    get colGroups(): any {
        return this._colgroups;
    }

    @Output() RateChangeOnlyChanged = new EventEmitter<boolean>();
    rateChangeOnly: boolean;

    numCols = 9;
    public dropdownItemHeight = environment.dropdownItemHeight;
    constructor(private log: LoggingService, private cdref: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {}

    setColGroupWidth(colgroups) {
        const colGroupWidth = `${colgroups[0].colspan * 128}px`;
        colgroups.forEach(v => {
            const colGroupTH = document.getElementById(`${v.field}`);
            colGroupTH.style.minWidth = colGroupWidth;
            colGroupTH.style.maxWidth = colGroupWidth;
        });
    }

    customSort(event: SortEvent) {
        this.log.verbose({
            type: 'IndirectRateHistoryPresenter:customSort',
            event
        });
        event.data.sort((data1, data2) => {
            let value1: any;
            let value2: any;
            if (event.field.includes('-')) {
                const group = event.field.split('-')[0];
                const field = event.field.split('-')[1];
                value1 = data1[group][field];
                value2 = data2[group][field];
            } else {
                value1 = data1[event.field];
                value2 = data2[event.field];
            }
            let result = null;

            if (value1 == null && value2 != null) {
                result = -1;
            } else if (value1 != null && value2 == null) {
                result = 1;
            } else if (value1 == null && value2 == null) {
                result = 0;
            } else if (
                typeof value1 === 'string' &&
                typeof value2 === 'string'
            ) {
                result = value1.localeCompare(value2);
            } else {
                result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
            }

            return event.order * result;
        });
    }

    // exportExcel() {
    //     import('xlsx').then(xlsx => {
    //         const worksheet = xlsx.utils.json_to_sheet(this.items);
    //         const workbook = {
    //             Sheets: { data: worksheet },
    //             SheetNames: ['data']
    //         };
    //         const excelBuffer: any = xlsx.write(workbook, {
    //             bookType: 'xlsx',
    //             type: 'array'
    //         });
    //         this.saveAsExcelFile(excelBuffer, 'indirect_rate_history_review');
    //     });
    // }

    // saveAsExcelFile(buffer: any, fileName: string): void {
    //     const EXCEL_TYPE =
    //         'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    //     const EXCEL_EXTENSION = '.xlsx';
    //     const data: Blob = new Blob([buffer], {
    //         type: EXCEL_TYPE
    //     });
    //     FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
    // }
}
